import React, { useState, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import moment from "moment"
import { withRouter } from "react-router";

/* MODALS */
import ModalExpiryDate from "../../Modals/ModalExpiryDate"

/* ACTIONS */
import {
  doListingExpiry,
  listSelling
} from "../../../actions/dashboardAction"

const RenderExpiryButton = ({
  children,
  onClick
}) => {
  return <button onClick={onClick ? onClick : null} style={{ textDecoration: 'underline', textDecorationColor: children.props.children === 'Expired' ? '#E02020' : '#242424' }}>{children}</button>
}

const ExpiryButtonWrapper = ({
  item,
  roles,
  doListingExpiry,
  listingExpiry,
  doListSelling,
  history
}) => {
  const {
    expiry,
    status,
    day_lefts,
    consignment_id,
    id,
    approved_at,
    product_variant,
    size,
    sneakers_condition,
    box_condition,
    missing_accessories,
    defects,
    sneakers_defect,
    product_variant_id,
    yellowing,
    display_item
  } = item || {}

  const {
    product_variant_images,
    product,
    display_name,
    SKU,
    slug,
    hide_box_info,
    vintage
  } = product_variant || {}

  const [isOpenModalExpiry, setIsOpenModalExpiry] = useState(false)
  const [isTextToggleAble, setIsTextToggleAble] = useState(false)
  const [dateExpiry, setDateExpiry] = useState(null)
  const [error, setError] = useState(null)
  const [renderExpiryText, setIsRenderExpiryText] = useState(<span className="selling-date expired non-underline">-</span>)
  const [expiryData] = useState({
    id: id,
    consignment_id: consignment_id,
    approved_at: approved_at,
    image: product_variant_images?.length
      ? product_variant_images[0]
      : null,
    brand_name: product.category.name === "lifestyles" ?
      (product?.brand?.name)
      :
      (product?.brand?.flat[0]),
    size: size.US,
    category: product.category.name,
    isVintage: vintage,
    SKU,
    display_name,
    sneakers_condition,
    box_condition,
    missing_accessories,
    defects,
    sneakers_defect,
    product_variant_id,
    slug,
    hide_box_info,
    yellowing,
    display_item
  })

  /* METHODS | FUCNTIONS | HANDLERS */
  const toggleModalExpiry = () => {
    setIsOpenModalExpiry(!isOpenModalExpiry)
  }

  const onChangeDate = (date) => {
    setDateExpiry(moment(date).format("YYYY-MM-DD 23:59:59"))
  }

  const validationExpiry = () => {
    if (dateExpiry === null) {
      setError("Please select expiry date!")
    }
  }

  const submitExpiry = (id) => {
    validationExpiry();

    if (error === null) {
      const payload = {
        expiry: dateExpiry,
      };
      doListingExpiry(id, payload).then(() => {
        doListSelling()
      });
    }
  }

  /* COMPONENT RENDERER */
  const renderExpiryTextHandler = () => {
    if (roles.includes('trusted_seller')) {
      return <span>No Expiry</span>
    }

    if (expiry) {
      if (status === "approved" && day_lefts <= 0) {
        setIsTextToggleAble(true)
        return <span className="is-expired">Expired</span>
      } else {
        setIsTextToggleAble(true)
        return <span>{moment(expiry).format('DD/MM/YYYY')}</span>
      }
    }

    return <span className="selling-date expired non-underline">-</span>
  }

  /* USE EFFECTS */
  useEffect(() => {
    setIsRenderExpiryText(renderExpiryTextHandler())
  }, [])

  useEffect(() => {
    if (listingExpiry.status_code === 200) {
      setIsOpenModalExpiry(false)
    }
  }, [listingExpiry])

  return (
    <>
      <RenderExpiryButton
        onClick={isTextToggleAble ? toggleModalExpiry : null}
      >
        {renderExpiryText}
      </RenderExpiryButton>
      {isOpenModalExpiry ? <ModalExpiryDate
        isOpen={isOpenModalExpiry}
        onToggle={() => setIsOpenModalExpiry(!isOpenModalExpiry)}
        value={dateExpiry}
        onChangeDate={onChangeDate}
        submitExpiry={submitExpiry}
        data={expiryData}
        history={history}
        id="new-expiry-modal"
        isProcessSubmit={listingExpiry.isSubmit}
        roles={roles}
        expiry={expiry}
        status={status}
        day_lefts={day_lefts}
      /> : null}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    roles: state.dataAuth.userdata.roles,
    listingExpiry: state.dataSelling.listingExpiry
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    doListingExpiry: (id, payload) => dispatch(doListingExpiry(id, payload)),
    doListSelling: (query: queryGetData, ascDesc?: any) =>
      dispatch(listSelling(query, ascDesc)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ExpiryButtonWrapper))